"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseContent = BaseContent;
exports.BaseData = void 0;

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _react = _interopRequireWildcard(require("react"));

var _data = require("../data");

var _hooks = require("../hooks");

var _description = require("../ui/description");

var _header = require("../ui/header");

var _dec,
    _dec2,
    _dec3,
    _class,
    _descriptor,
    _descriptor2,
    _descriptor3,
    _temp,
    _jsxFileName = "/home/ackwell/code/xivanalysis/tooltips/src/detail/base.tsx";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var BaseData = (_dec = (0, _data.column)('Name'), _dec2 = (0, _data.column)('Icon', {
  type: 'url'
}), _dec3 = (0, _data.column)('Description'), (_class = (_temp = /*#__PURE__*/function (_Data) {
  (0, _inherits2["default"])(BaseData, _Data);

  var _super = _createSuper(BaseData);

  function BaseData() {
    var _this;

    (0, _classCallCheck2["default"])(this, BaseData);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2["default"])(_this, "name", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "icon", _descriptor2, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "description", _descriptor3, (0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  return BaseData;
}(_data.Data), _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "icon", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "description", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
exports.BaseData = BaseData;

function BaseContent(_ref) {
  var _data$name;

  var sheet = _ref.sheet,
      id = _ref.id,
      onUpdate = _ref.onUpdate;
  var data = (0, _hooks.useGameData)({
    sheet: sheet,
    columns: BaseData,
    id: id
  }); // Each time data is modified, trip update effect

  (0, _react.useEffect)(function () {
    return onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate();
  }, [onUpdate, data]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_header.Header, {
    title: (_data$name = data === null || data === void 0 ? void 0 : data.name) !== null && _data$name !== void 0 ? _data$name : 'Loading',
    icon: (data === null || data === void 0 ? void 0 : data.icon) && /*#__PURE__*/_react["default"].createElement("img", {
      src: data.icon,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28,
        columnNumber: 25
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 4
    }
  }), data && /*#__PURE__*/_react["default"].createElement(_description.Description, {
    html: data.description,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 13
    }
  }));
}